module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/fails.js
// module id = 4
// module chunks = 49